import React from "react";
import {IconXMark} from "@unibuddy/icons";
import styled from "styled-components";

const StyledAside = styled.aside`
    animation-name: rubberBand;
    animation-duration: 1s;
    margin-left: 3px;
    background-color: #fff;
    border-radius: 30px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 20px;
    margin-bottom: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: fit-content;
`;

const StyledButton = styled.button`
    height: 42px;
    white-space: normal;
    padding: 10px 0px 10px 15px;
    border: none;
    background: none;
    font-weight: normal;
    font-size: 0.92rem;
    font-family: proxima-nova, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans,
        Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    color: ${({theme}) => theme.TextBlock.color};
    &:hover {
        background-color: ${({theme}) => theme.colors.grey100};
    }

    &:active {
        background-color: ${({theme}) => theme.colors.grey200};
    }
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
    padding-left: 20px;
    padding-right: 5px;
`;

const StyledCloseButton = styled.button`
    border: none;
    background: none;
    padding: 0 10px 0 5px;
    height: 42px;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
    &:hover {
        background-color: ${({theme}) => theme.colors.grey100};
    }

    &:active {
        background-color: ${({theme}) => theme.colors.grey200};
    }
`;

export const DEFAULT_PROMPT_VALUE = "Hi, do you need any help?";
export const CLOSE_PROMPT_LABEL = "Close Prompt";

type WidgetTrafficDriverPromptProps = {
    onPromptClose: () => void;
    onPromptClick: () => void;
    promptActive: boolean;
};

export function WidgetTrafficDriverPrompt({
    onPromptClose,
    onPromptClick,
    promptActive,
}: WidgetTrafficDriverPromptProps) {
    const searchParams = new URLSearchParams(window.location.search);
    const promptValue = searchParams.get("promptValue") || DEFAULT_PROMPT_VALUE;
    return (
        promptActive && (
            <StyledAside>
                <StyledButton onClick={onPromptClick}>{promptValue}</StyledButton>
                <StyledCloseButton onClick={onPromptClose} aria-label={CLOSE_PROMPT_LABEL}>
                    <IconXMark width={"14px"} height={"26px"} />
                </StyledCloseButton>
            </StyledAside>
        )
    );
}
